import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  GET_DRIVER_REQUEST_TEMPLATES: createSagaAction('GET_DRIVER_REQUEST_TEMPLATES')
}

// Action Creators
export const actions = {
  getDriverRequestTemplates: () => ({
    type: constants.GET_DRIVER_REQUEST_TEMPLATES.ACTION
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.GET_DRIVER_REQUEST_TEMPLATES.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_DRIVER_REQUEST_TEMPLATES.SUCCESS:
      return {
        ...state,
        driverRequestTemplates: action.payload
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/driverRequestTemplatesActions.js